import { Cell, Grid, HeadingSection, HFlow, Icon, Text } from 'bold-ui'
import React from 'react'

interface CidadaoFciCompartilhaProntuarioSectionProps {
  statusCompartilhaProntuario: boolean
}

export const CidadaoFciCompartilhaProntuarioSection = (props: CidadaoFciCompartilhaProntuarioSectionProps) => {
  const { statusCompartilhaProntuario } = props

  return (
    <HeadingSection level={2} title='Compartilhamento de prontuário'>
      <Grid wrap>
        <Cell size={6}>
          <Text>
            Por padrão, o prontuário do cidadão é visível por todas as unidades de saúde de uma mesma instalação do
            e-SUS AB, para agilizar o atendimento em toda a rede. Se o cidadão não concorda com essa condição, atualize
            o cadastro marcando a opção "Desativar compartilhamento de prontuário para este cidadão".
          </Text>
        </Cell>
        <Cell size={6} />
        <Cell size={4}>
          <HFlow alignItems='center' hSpacing={0.5}>
            {statusCompartilhaProntuario ? (
              <>
                <Icon icon='checkCircleOutline' size={1} fill='success' />
                <Text color='success'>Compartilhamento de prontuário ativo</Text>
              </>
            ) : (
              <>
                <Icon icon='banOutline' size={1} fill='danger' />
                <Text color='danger'>Compartilhamento de prontuário inativo</Text>
              </>
            )}
          </HFlow>
        </Cell>
      </Grid>
    </HeadingSection>
  )
}
